import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();
export const ft3ReplayRouteRef = createRouteRef();
